import { captureException } from '@sentry/react'
import React, { useEffect, useState } from 'react'
import ErrorLabel from 'ui/atoms/ErrorLabel'

import { invalidateLoadStripeCustomer } from '@/queries/payments/useLoadStripeCustomer'

import api from '../../api'
import MessageBar from '../../ui/MessageBar'
import {
  error,
  initial,
  isError,
  isInitial,
  isLoading,
  isSuccess,
  loading,
  success,
} from '../../utils/remoteData'
import Spinner from '../Spinner'

export function ConfirmPayment({ setup_intent, client_secret }) {
  const [verifyPaymentRequest, setVerifyPaymentRequest] = useState(initial())

  useEffect(() => {
    async function pushData() {
      if (setup_intent && client_secret && isInitial(verifyPaymentRequest)) {
        setVerifyPaymentRequest(loading())
        try {
          const { error: backendError } = await api.setDefaultPayment(
            setup_intent,
            client_secret
          )
          if (backendError) {
            setVerifyPaymentRequest(error(backendError.message))
            return
          }

          await invalidateLoadStripeCustomer()
        } catch (err) {
          setVerifyPaymentRequest(
            error('Sorry something went wrong, please contact us')
          )
          captureException(err)
          return
        }
        setVerifyPaymentRequest(success())
      }
    }
    pushData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setup_intent, client_secret, verifyPaymentRequest])

  return (
    <div>
      {isLoading(verifyPaymentRequest) && (
        <div className="mt-3 flex flex-1 justify-center">
          <Spinner color="onLight" size="56" />
        </div>
      )}
      {isSuccess(verifyPaymentRequest) && (
        <MessageBar noMargin>
          Card verified.
          <br />
          You can now enjoy using Zentake.
        </MessageBar>
      )}
      {isError(verifyPaymentRequest) && (
        <div className="flex flex-1 justify-center">
          <ErrorLabel>{verifyPaymentRequest.error}</ErrorLabel>
        </div>
      )}
    </div>
  )
}
export default ConfirmPayment
